var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscapeImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H1.5A1.5 1.5 0 000 1.5V15a1.5 1.5 0 001.5 1.5H18a1.5 1.5 0 001.5-1.5V1.5A1.5 1.5 0 0018 0zm0 1.5v9.633L15.556 8.69a1.5 1.5 0 00-2.122 0l-1.875 1.875L7.434 6.44a1.5 1.5 0 00-2.12 0L1.5 10.253V1.5H18zM1.5 12.375L6.375 7.5l7.5 7.5H1.5v-2.625zM18 15h-2.003l-3.375-3.375 1.875-1.875L18 13.254V15zm-6.75-9.375a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
  })));
}
export default SvgLandscapeImage;